import 'slick-carousel';
import Aos from 'aos';
import { Calendar } from 'fullcalendar';
import Pikaday from 'pikaday';
import { google, outlook, office365, yahoo, ics } from "calendar-link";

jQuery( document ).ready(function($) {
    $('.news-wrapper').slick({
        slidesToShow: 3,
        variableWidth: true,
        infinite: false,
        centerMode: true,
        initialSlide: 1,
        arrows: true,
        prevArrow:'<button type="button" class="slick-prev"><i class="far fa-chevron-left"></i></button>',
        nextArrow:'<button type="button" class="slick-next"><i class="far fa-chevron-right"></i></button>',
    })

    $('.photo-carousel').slick({
        slidesToShow: 1,
        infinite: true,
        arrows: true,
        prevArrow:'<button type="button" class="slick-prev"><i class="far fa-chevron-left"></i></button>',
        nextArrow:'<button type="button" class="slick-next"><i class="far fa-chevron-right"></i></button>',
    })
    if ($('.cal-menu').length){ 
        $('.cal-menu').each(function(){
            let eventinfo = {
                title: $(this).attr('data-title'),
                description: $(this).attr('data-desc'),
                start: $(this).attr('data-start'),
                location: $(this).attr('data-loc'),
            };
            let html = "<span>Add To Calendar</span>";
            html+= "<a target='_blank' href='" + google(eventinfo) + "'><span class='sr-only'>Add" + eventinfo['title'] + " on</span> Google</a>";
            html+= "<a target='_blank' href='" + outlook(eventinfo) + "'><span class='sr-only'>Add" + eventinfo['title'] + " on</span> Outlook</a>";
            html+= "<a target='_blank' href='" + office365(eventinfo) + "'><span class='sr-only'>Add" + eventinfo['title'] + " on</span> Office365</a>";
            html+= "<a target='_blank' href='" + yahoo(eventinfo) + "'><span class='sr-only'>Add" + eventinfo['title'] + " on</span> Yahoo</a>";
            html+= "<a target='_blank' href='" + ics(eventinfo) + "'><span class='sr-only'>Add" + eventinfo['title'] + " on</span> iCal</a>";
            console.log(html);
            $(this).find('.menu').html(html);
        })
    };

    $('#main').on('click', '.selector', function(e){
        e.preventDefault();
        let targets = $(this).attr('data-target');
        let newActive = $(this).attr('href');
        if ($(this).hasClass('active')){
            $(this).removeClass('active'); 
            $(targets).removeClass('active');
        } else {
            $(targets).removeClass('active');
            $(this).addClass('active');
            $(newActive).addClass('active');
        }
        //fix carousels
        $('.slick-slider').slick("resize");
        setTimeout(function(){
            $('.slick-slider').slick("resize");
        }, 100);
    })

    $('.menu-toggle').on('click', function(e){
        e.preventDefault();
        $('.menu-wrapper').toggleClass('open');
    })

    $('.filter-toggle').on('click', function(e){
        e.preventDefault();
        $('.filters').toggle();
    })

    $( '#calendar' ).each( function () {
        var events = JSON.parse( $( this ).attr( 'data-events' ) );
        var listURL = $( this ).attr( 'data-list' );
        var cal = $( this );
        let calendarEl = cal[0];
        console.log(events);

        let calendar = new Calendar(calendarEl, {
            defaultView: 'month',
            eventOrder: 'start',
            weekends: false,
            height: 'auto',
            fixedWeekCount: false,
            events: events,
            customButtons: {
                datepicker: { 
                    icon: 'fa far fa-calendar',
                    text:'Date',
                    click: function(e) {
                        picker.show();
                    }
                },
                backToActivity: {
                  text: 'List View',
                  click: function() {
                    window.location.href = listURL;
                  }
                }
            },
            headerToolbar: {
                left: 'prev next today',
                center: 'title',
                right: 'datepicker backToActivity'
            },
        } );

        calendar.render();
        var picker = new Pikaday({
            field: document.querySelector('.fc-datepicker-button'),
            format: 'yy-mm-dd',
            yearRange: [2023, 2030],
            onSelect: function(dateString) {
                picker.gotoDate(new Date(dateString));
                calendar.gotoDate(new Date(dateString));
            }
        });
    });

    
    
    Aos.init();
});